var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconsPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0554b4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.6 16 2.3 1.3-1 1.8-2.4-1.4v2.6h-2v-2.6L1.2 19l-1-1.8L2.5 16 .2 14.7l1-1.8 2.4 1.4v-2.6h2v2.6L7.9 13l1 1.8L6.6 16zM18 16l2.3 1.3-1 1.8-2.3-1.5v2.6h-2v-2.6L12.7 19l-1-1.8L14 16l-2.3-1.3 1-1.8 2.4 1.4v-2.6h2v2.6l2.4-1.4 1 1.8L18 16zM29.5 16l2.3 1.3-1 1.8-2.4-1.4v2.6h-2v-2.6L24.1 19l-1-1.8 2.3-1.3-2.3-1.3 1-1.8 2.4 1.4v-2.6h2v2.6l2.4-1.4 1 1.8-2.4 1.4z",
    className: "st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconsPassword);
export default __webpack_public_path__ + "static/media/profile_icons_password.febeafe006515bacf26fa16efb4c0573.svg";
export { ForwardRef as ReactComponent };